module.exports = __webpack_public_path__ + "static/member-profile-nandy-0454edfc89365f84b33bbc3a8e3d0e03.jpg";